const cdwSizeBrowsers = document.querySelectorAll('[data-cdw-size-browser]');

const cdwSizeDimensions = (title) => title.split(' - ')[1]?.trim() || '';

const cdwSizeWidth = (title) => {
  const match = cdwSizeDimensions(title).match(/([\d.]+)\s*[”\"]W/i);
  return match ? Number(match[1]) : Number.POSITIVE_INFINITY;
};

const cdwSizeMoney = (value) => {
  const amount = Number.parseFloat(value || 0);
  const currency = window.Shopify?.currency?.active || 'USD';
  const locale = document.documentElement.lang || 'en-US';
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
};

const cdwSizeNode = (tag, className, text) => {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text) node.textContent = text;
  return node;
};

const cdwRenderSizeCard = (product, currentHandle) => {
  const productHandle = product.url.split('/products/')[1]?.split('?')[0] || '';
  const dimensions = cdwSizeDimensions(product.title);
  const width = cdwSizeWidth(product.title);
  const card = cdwSizeNode('a', 'cdw-product-size-card');
  card.href = product.url;
  card.setAttribute('aria-label', `${dimensions || product.title}, ${cdwSizeMoney(product.price)}`);

  if (productHandle === currentHandle) card.setAttribute('aria-current', 'page');

  const media = cdwSizeNode('span', 'cdw-product-size-card__media');
  const image = document.createElement('img');
  image.src = product.featured_image.url;
  image.alt = product.featured_image.alt || `${dimensions} cabinet drawing`;
  image.loading = 'lazy';
  image.decoding = 'async';
  media.append(image);

  const copy = cdwSizeNode('span', 'cdw-product-size-card__copy');
  copy.append(cdwSizeNode('strong', 'cdw-product-size-card__width', Number.isFinite(width) ? `${width}″ wide` : 'View size'));
  copy.append(cdwSizeNode('span', 'cdw-product-size-card__dimensions', dimensions));

  const footer = cdwSizeNode('span', 'cdw-product-size-card__footer');
  footer.append(cdwSizeNode('span', '', cdwSizeMoney(product.price)));
  footer.append(cdwSizeNode('span', 'cdw-product-size-card__current', productHandle === currentHandle ? 'Current size' : 'View →'));
  copy.append(footer);
  card.append(media, copy);
  return card;
};

const cdwLoadSizeBrowser = async (section) => {
  const query = section.dataset.query || '';
  const matchPrefix = section.dataset.matchPrefix || '';
  const currentHandle = section.dataset.currentHandle || '';
  const rail = section.querySelector('[data-cdw-size-results]');
  const status = section.querySelector('[data-cdw-size-status]');
  if (!query || !matchPrefix || !rail || !status) return;

  try {
    const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`;
    const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Size search failed: ${response.status}`);

    const payload = await response.json();
    const products = (payload.resources?.results?.products || [])
      .filter((item) => item.title.includes(matchPrefix) && item.featured_image?.url)
      .sort((a, b) => cdwSizeWidth(a.title) - cdwSizeWidth(b.title));

    if (products.length < 2) return;

    products.forEach((product) => rail.append(cdwRenderSizeCard(product, currentHandle)));
    status.hidden = true;
    section.hidden = false;
  } catch (error) {
    console.warn('[CDW] Related cabinet sizes unavailable.', error);
  }
};

cdwSizeBrowsers.forEach(cdwLoadSizeBrowser);
